module.exports = __webpack_public_path__ + "img/Agile_&_Scrum_Practices.cb412976.jpeg";